module.exports = __webpack_public_path__ + "img/placeholder-3.24f4a9d7.jpg";